// extracted by mini-css-extract-plugin
module.exports = {"DateParagraph":"NotificationCard_DateParagraph__1gl4x","IconDiv":"NotificationCard_IconDiv__gb_1U","TextDiv":"NotificationCard_TextDiv__3YdN2"};